import React from "react"
import { Link } from "gatsby"

import SEO from "../components/seo"

import Layout from "../components/layout"
import Summary from "../components/summary/summary"
import ScreensBanner from "../components/screens-banner/screens-banner"


const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
      <Summary/>
      <ScreensBanner/>
      <Link className="bannerlink" to="/gettingstarted">
        Go and get started
      </Link>
  </Layout>
)

export default IndexPage
